import { render, staticRenderFns } from "./ViewFormRF05.vue?vue&type=template&id=376c906c"
import script from "./ViewFormRF05.vue?vue&type=script&lang=js"
export * from "./ViewFormRF05.vue?vue&type=script&lang=js"
import style0 from "./ViewFormRF05.vue?vue&type=style&index=0&id=376c906c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports